import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  loading: false,
  isError: false,
  errorDetails: {},
  errorMsg: ''
};

const acountsSlice = createSlice({
  name: 'accounts',
  initialState: INITIAL_STATE,
  reducers: {
    startLoading(state) {
      state.errorDetails = {};
      state.loading = true;
    },
    stopLoading(state) {
      state.loading = false;
    },
    setError(state, { payload }) {
      state.errorDetails = payload;
    },
    emptyState(state) {
      state.errorDetails = {};
      state.errorMsg = '';
    },
    setErrorMsg(state, { payload }) {
      state.errorMsg = payload;
    }
  }
});

export const accountsAction = acountsSlice.actions;

export default acountsSlice.reducer;
